import { Navigate, type RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// Service desk (HaloPSA / Zendesk). Owned by the tickets module.
export const routes: RouteObject[] = [
  { path: 'tickets', lazy: page(() => import('./tickets-page'), (m) => m.TicketsPage) },
  { path: 'tickets/board', lazy: page(() => import('./ticket-board'), (m) => m.TicketBoardPage) },
  { path: 'tickets/new', lazy: page(() => import('./new-ticket-page'), (m) => m.NewTicketPage) },
  { path: 'tickets/settings', lazy: page(() => import('./settings-page'), (m) => m.TicketSettingsPage) },
  { path: 'tickets/approvals', lazy: page(() => import('./approvals-page'), (m) => m.MyApprovalsPage) },
  { path: 'tickets/sla-report', element: <Navigate to="/reports/sla" replace /> }, // P2-4 (BUG-59): moved to Reports
  { path: 'tickets/:ticketId', lazy: page(() => import('./ticket-detail-page'), (m) => m.TicketDetailPage) },
];
export const orgRoutes: RouteObject[] = [{ path: 'tickets', lazy: page(() => import('./org-tickets'), (m) => m.OrgTicketsPage) }];
